import { InterpolationWithTheme } from "@emotion/core";
import mq from "../../../mediaQuery";



export const familyHistoryStyles: { [key: string]: any } = {
    typeAheadContainer: {
        // width: "150px"
    },
    tagsHeader: {
        color: "#335e90",
        fontFamily: "BrandonTextWeb-Medium",
        marginBottom: "5px"
    },
    editIcon: {
        fontSize: "12px",
        marginRight: "5px"
    },
    editBtn: {
        position: "relative",
        top: "-70px",
        left: "calc(100vw - 215px)",
        color: "rgb(255, 49, 109)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "16px",
        fontWeight: 500,
        background: "#ffffff",
        border: "none",
        [mq[0]]: {
            left: "calc(100vw - 135px)",
        }
    },
    habitsEdit: {
        [mq[0]]: {
            top: "-37px",
            left: "calc(100vw - 135px)",
        }
    },
    allergyEdit: {
        position: "relative",
        top: "-105px",
        // left: "calc(100vw - 215px)",
        right: "25px",
        float: "right",
        color: "rgb(255, 49, 109)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "16px",
        fontWeight: 500,
        background: "#ffffff",
        border: "none",
        [mq[0]]: {
            right: "35px"
        }
    },
    commonlyUsedComntainer: {
        borderRadius: "5px",
        border: "1px solid rgb(216, 216, 216)",
        padding: "25px 10px"
    },
    selectedDiseaseRow: {
        display: "flex",
        justifyContent: "space-between",
        margin: "10px 0px",
        border: "1px solid rgb(216, 216, 216)",
        borderRadius: "5px",
        padding: "15px"
    },
    readOnlyRow: {
        margin: "10px 0px",
        borderRadius: "5px",
        padding: "15px",
        background: "rgb(246, 249, 252)"
    },
    relationShipItem: {
        display: "flex"
    },
    verticalMiddle: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        flex: 1,
        color: "rgb(0, 0, 0)",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "18px",
        fontWeight: "bold",
        marginBottom: "10px",
        [mq[0]]: {
            width: "80%"
        }
    },
    actionWrapper: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        color: "#ff316d",
        [mq[0]]: {
            position: "absolute",
            right: 0,
            top: "-30px"
        }
    },
    listLabel: {
        marginBottom: "10px"
    },
    groupLabel: {
        color: "rgb(145, 151, 171)",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "12px",
        fontWeight: "bold",
        textTransform: "capitalize",
        marginBottom: "10px",
        [mq[0]]: {
            fontSize: "14px"
        }
    },
    relationshipBtns: {
        background: "rgb(255, 255, 255)",
        borderRadius: "15px",
        border: "1px solid rgb(215, 215, 215)",
        padding: "5px 25px",
        marginRight: "5px",
        marginBottom: "20px"
    },
    itemsWrapper: {
        display: "flex",
        justifyContent: "space-between",
        position: "relative"
    },
    itemsWrapperReadOnly: {
        display: "flex",
        justifyContent: "flex-start",
        color: "#666666",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "16px"
    },
    itemsContainer: {
        flex: 2,
    },
    icons: {
        margin: "0px 10px",
        cursor: "pointer"
    },
    selectedBtn: {
        background: "#e5316e",
        color: "#ffffff",
        borderRadius: "15px",
        border: "1px solid rgb(215, 215, 215)",
        padding: "5px 25px",
        marginRight: "5px",
        marginBottom: "10px"
    },
    transparentBtn: {
        border: "none",
        background: "transparent",
        color: "rgb(255, 49, 109)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "16px",
        fontWeight: 500,
        marginTop: 10
    },
    bottonCta: {
        textAlign: "right",
        margin: "5px"
    },
    sectionElement: {
        [mq[0]]: {
            marginBottom: "20px"
        }
    },
    mobileColView: {
        [mq[0]]: {
            flexDirection: "column"
        }
    }
}